module.exports = __webpack_public_path__ + "icons/icon-info.e8280ef8.svg";